import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';

const initialState = () => ({
  profile: null,
  fieldMappings: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  loadProfile({ commit }, profileId) {
    return opportunitySyncProfilesService.getSyncProfile(profileId).then(
      (response) => {
        commit('SET_PROFILE', response);
        return response;
      },
      (error) => {
        throw error;
      },
    );
  },
  getFieldMappings({ commit }, profileId) {
    commit('GET_FIELD_MAPPINGS');
    return opportunitySyncProfilesService.getFieldMappings({ syncProfileId: profileId }).then(
      (response) => {
        commit('SUCCESS_GET_FIELD_MAPPINGS', response);
        return response;
      },
      (error) => {
        commit('ERROR_GET_FIELD_MAPPINGS', error);
        throw error;
      },
    );
  },
  createFieldMapping({ commit }, { profileId, mapping }) {
    commit('MUTATE_START');
    return opportunitySyncProfilesService.createFieldMapping(profileId, mapping).then(
      (response) => {
        commit('MUTATE_SUCCESS');
        return response;
      },
      (error) => {
        commit('MUTATE_ERROR', error);
        throw error;
      },
    );
  },
  updateFieldMapping({ commit }, { profileId, mappingId, mapping }) {
    commit('MUTATE_START');
    return opportunitySyncProfilesService.updateFieldMapping(profileId, mappingId, mapping).then(
      (response) => {
        commit('MUTATE_SUCCESS');
        return response;
      },
      (error) => {
        commit('MUTATE_ERROR', error);
        throw error;
      },
    );
  },
  deleteFieldMapping({ commit }, { profileId, mappingId }) {
    commit('MUTATE_START');
    return opportunitySyncProfilesService.deleteFieldMapping(profileId, mappingId).then(
      (response) => {
        commit('MUTATE_SUCCESS');
        return response;
      },
      (error) => {
        commit('MUTATE_ERROR', error);
        throw error;
      },
    );
  },
};

const mutations = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  GET_FIELD_MAPPINGS(state) {
    state.status = { error: null, pending: true, resolved: false, rejected: false };
  },
  SUCCESS_GET_FIELD_MAPPINGS(state, fieldMappings) {
    state.status = { ...state.status, pending: false, resolved: true };
    state.fieldMappings = fieldMappings;
  },
  ERROR_GET_FIELD_MAPPINGS(state, error) {
    state.status = { error, pending: false, resolved: false, rejected: true };
    state.fieldMappings = [];
  },
  MUTATE_START(state) {
    state.status = { ...state.status, error: null, pending: true };
  },
  MUTATE_SUCCESS(state) {
    state.status = { ...state.status, pending: false, resolved: true };
  },
  MUTATE_ERROR(state, error) {
    state.status = { error, pending: false, resolved: false, rejected: true };
  },
};

const getters = {
  profile: (state) => state.profile,
  fieldMappings: (state) => state.fieldMappings,
  pending: (state) => state.status.pending,
  error: (state) => state.status.error,
};

export const adminSyncProfileFieldMappings = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
